import React from "react";
import * as styles from "./style.mod.scss";
import { useMediaQuery } from "react-responsive";
import Image from "components/image";

const CartBanner = ({ data }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  if (!data?.showBanner) return<></>;
  return (
    <div className={styles.cartBanner}>
      {isMobile ? 
        <Image image={data?.mobileBanner} alt={data?.mobileBanner?.alt} /> :
        <Image image={data?.desktopBanner} alt={data?.desktopBanner?.alt} />
      }

    </div>
  );
};

export default CartBanner;